import httpRequest from "@/utils/api";
import type { Topic, Category, Question } from "@/types/topic/topic";
enum API {
  fetchTopics = "/speaking/topic/",
  fetchVisibleTopics = "/speaking/topic/visible",
  fetchTopicById = "/speaking/topic/id/",
  fetchTopicBySlug = "/speaking/topic/slug/",
  fetchCategories = "/speaking/topic/all-categories",
  putTopicCategory = "/speaking/topic/category/update",
  putTopicVisibility = "/speaking/topic/visibility",
  putTopicIsNew = "/speaking/topic/is-new",
  generateAudio = "/speaking/topic/generate-audio",
  putQuestionVisibility = "/speaking/question/visibility",
  putQuestionOrder = "/speaking/question/order",
  fetchLastUpdateTime = "/speaking/topic/last-update-time",
  updateTopic = "/speaking/topic/update",
  updateQuestion = "/speaking/topic/question/update",
  updateTopicOrder = "/speaking/topic/order/update",
  updateQuestionOrder = "/speaking/topic/question/order/update",
}

export const fetchTopicsAPI = (partId: number, categoryId: number) => {
  return httpRequest.get<Topic[]>({
    url: API.fetchTopics,
    params: {
      categoryId,
      partId,
    },
  });
};
export const fetchVisibleTopicsAPI = (partId: number, categoryId: number) => {
  return httpRequest.get<Topic[]>({
    url: API.fetchVisibleTopics,
    params: {
      categoryId,
      partId,
    },
  });
};

export const fetchTopicByIdAPI = (topicId: string) => {
  return httpRequest.get<Topic>({
    url: API.fetchTopicById + topicId,
  });
};

export const fetchTopicBySlugAPI = (topicSlug: string) => {
  return httpRequest.get<Topic>({
    url: API.fetchTopicBySlug + topicSlug,
  });
};

export const fetchCategoriesAPI = () => {
  return httpRequest.get<Category[]>({
    url: API.fetchCategories,
  });
};

export const putTopicCategoryAPI = (topicId: string, newCategoryId: number) => {
  return httpRequest.put<void>({
    url: API.putTopicCategory,
    data: {
      topicId,
      newCategoryId,
    },
  });
};

export const putTopicVisibilityAPI = (topicId: string, isVisible: boolean) => {
  return httpRequest.put<void>({
    url: API.putTopicVisibility,
    data: {
      topicId,
      isVisible,
    },
  });
};

export const putTopicIsNewAPI = (topicId: string, isNew: boolean) => {
  return httpRequest.put<void>({
    url: API.putTopicIsNew,
    data: {
      topicId,
      isNew,
    },
  });
};

export const generateAudioAPI = (
  answer: string,
  questionId: string,
  question: string
) => {
  return httpRequest.post<void>({
    url: API.generateAudio,
    data: {
      answer,
      questionId,
      question,
    },
  });
};

export const putQuestionVisibilityAPI = (questionId: string, isVisible: boolean) => {
  return httpRequest.put<void>({
    url: API.putQuestionVisibility,
    data: {
      questionId,
      isVisible,
    },
  });
};

export const putQuestionOrderAPI = (topicId: string, questionOrder: string[]) => {
  return httpRequest.put<void>({
    url: API.putQuestionOrder,
    data: {
      topicId,
      questionOrder,
    },
  });
};

export const fetchLastUpdateTimeAPI = () => {
  return httpRequest.get<{ last_update_time: string }>({
    url: API.fetchLastUpdateTime,
  });
};

export const updateTopicAPI = (topicId: number, topicName: string) => {
  return httpRequest.put({
    url: API.updateTopic,
    data: {
      topicName: topicName,
      topicId: topicId,
    },
  });
};

export const updateQuestionAPI = (questionId: string, questionText: string) => {
  return httpRequest.put<Question>({
    url: API.updateQuestion,
    data: {
      questionText,
      questionId,
    },
  });
};

export const updateTopicOrderAPI = (topicIds: number[]) => {
  return httpRequest.put<void>({
    url: API.updateTopicOrder,
    data: {
      topic_ids: topicIds
    }
  });
};

export const updateQuestionOrderAPI = (topicId: string, questionIds: string[]) => {
  return httpRequest.put<void>({
    url: API.updateQuestionOrder,
    data: {
      topic_id: topicId,
      question_ids: questionIds,
    },
  });
};

